import request from '@/utils/request'

/**
 * 上传图片
 * @param {FormData} formData 包含uploadFile和communityId的表单数据
 * @returns {Promise}
 */
export function uploadImage(formData) {
  return new Promise((resolve, reject) => {
    request({
      url: '/callComponent/upload/uploadFile/uploadImage',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0 || res.url) {
        // 兼容不同的返回格式
        resolve(res)
      } else {
        reject(new Error(res.msg || '上传图片失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取用户签名图片
 * @param {Object} params { userId }
 * @returns {Promise}
 */
export function getSignPic(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.getSignPic',
      method: 'get',
      params: params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取签名失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取用户已绑定的技能分类
 * @param {Object} params { userId }
 * @returns {Promise}
 */
export function getUserCategorys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.getUserCategorys',
      method: 'get',
      params: params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取用户技能失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新用户签名图片 / 绑定技能
 * @param {Object} data { userId, picUrl } 或 { userId, categoryIds } categoryIds为逗号分隔的字符串
 * @returns {Promise}
 */
export function updateUserSignPic(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.updateUserSignPic',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '更新签名失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
